<script>
import api from '@/utils/api'
import ApiErrorMixin from '@/mixins/apiErrorMixin'

export default {
  name: 'DictionaryMixin',
  mixins: [ApiErrorMixin],
  methods: {
    async getDictionaries (path, params, withPagination) {
      let models
      if (withPagination) {
        models = {}
        const requestResponse = await api.requestAll({ path, params })
        if (requestResponse.headers['x-total-count']) {
          models.pagination = parseInt(requestResponse.headers['x-total-count'], 10)
        } else {
          models.pagination = 50
        }
        const responseData = requestResponse.data
        models.data = this.checkApiResponse(responseData) || []
        return models
      } else {
        const requestResponse = await api.findAll({ path, params })
        models = this.checkApiResponse(requestResponse)
      }
      return models || []
    }
  }
}

</script>
